import React, { Component } from 'react'

import PlusMinus from '../PlusMinus/'
import FormPopup from '../FormPopup/'
import { Dots } from '../../components/Icons'
import {
  Box,
  BoxHeader,
  ItemList,
  ItemListInner,
  Item,
  ItemName,
  ItemContent,
  ItemLink,
  IconContainer,
  Edit,
  EditIconContainer
} from './styles'

class Detail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupActive: false,
      boxActive: false
    }
  }

  openPopup() {
    if (!this.state.popupActive) {
      this.setState({ popupActive: true })
      document.body.classList.add('popup-active')
      document.documentElement.classList.add('popup-active')
    }
  }

  closePopup() {
    this.setState({ popupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }

  toggleBox() {
    this.setState({ boxActive: !this.state.boxActive })
  }

  hasContent(item) {
    return item.content !== ''
  }

  render() {
    const { title, items, formFields } = this.props
    const { boxActive } = this.state

    return (
      <Box>
        <BoxHeader onClick={this.toggleBox.bind(this)}>
          <h2>{title}</h2>

          {formFields ? (
            <IconContainer onClick={this.openPopup.bind(this)}>
              <Dots size='' />
            </IconContainer>
          ) : null}

          <PlusMinus active={boxActive} />
        </BoxHeader>

        <ItemList active={boxActive}>
          <ItemListInner>
            {items &&
              items.filter(this.hasContent).map((item, index) => {
                return (
                  <Item key={index}>
                    <ItemName>{item.title}</ItemName>
                    <ItemContent>
                      {item.href !== '' ? (
                        <ItemLink href={item.href}>{item.content}</ItemLink>
                      ) : (
                        <span>{item.content}</span>
                      )}

                      {item.subcontent !== '' ? <span>{item.subcontent}</span> : null}
                    </ItemContent>
                  </Item>
                )
              })}

            {formFields ? (
              <Edit onClick={this.openPopup.bind(this)}>
                <EditIconContainer>
                  <Dots size='' />
                </EditIconContainer>
                <span>Wijzigen</span>
              </Edit>
            ) : null}
          </ItemListInner>
        </ItemList>

        {formFields && this.state.popupActive ? (
          <FormPopup
            onSubmitForm={this.props.updateBranch}
            data={this.props.data}
            loading={this.props.loading}
            error={this.props.error}
            closePopup={this.closePopup.bind(this)}
            doesntNeedBranches={true}
            fields={formFields}
            title='Contactgegevens wijzigen'
            id={this.props.id}
            clearForm={false}
            errorMessage='Foutieve of lege velden, controleer formulier'
            succesMessage='Bedrijfsgegevens gewijzigd'
          />
        ) : null}
      </Box>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/components/Detail/index.js